//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IApplicationsClient {

    resetCache(): Promise<void>;

    getMunicipalityCode(postalCode?: string | null | undefined): Promise<void>;

    /**
     * Gets information related to creating new application (e.g. Objective and Type hierarchy for Development applications)
     */
    getApplicationCreationInformation(): Promise<ApplicationCreationInformation>;

    /**
     * Get updated cluster information from portal.
     */
    getUpdatedClusterInformation(): Promise<ClusterInformation>;

    /**
     * Get "main" application which will contain an Operation application (if applicable) and a collection of development applications (if applicable).
    Content will depend on which status the authenticated users cluster has.
     */
    getApplicationOverview(): Promise<CompleteApplicationDto>;

    /**
     * Create a new main application.
     * @return When appliction is created
     */
    createCompleteApplication(): Promise<void>;

    /**
     * Gets a list of applications that are submitted for current cluster. 
    Only "Main" applications are listed, since they are combined into one application when passed on from WebApplication
     */
    getArchivedApplications(): Promise<SubmittedFormMetadata[]>;

    /**
     * Gets the actual PDF file which is the main application from ApplicationMaster
     * @param applicationId Id of the application in appid|accountId format
     * @return File result with contents
     */
    getArchivedApplicationAsPdf(applicationId: string | null): Promise<FileResponse>;

    /**
     * Gets the actual DOCX file which is the main application from Archive system via ApplicationMaster
     * @param applicationId Id of the application in appid|accountId format
     * @return File result with contents
     */
    getArchivedApplicationAsDocx(applicationId: string | null): Promise<FileResponse>;

    /**
     * Get "main" application which will contain an Operation application (if applicable) and a collection of development applications (if applicable).
    If there are no existing applications, a main application, and an operation application if it should be there, will be created.
    Content will depend on which status the authenticated users cluster has.
     */
    createApplicationSetup(): Promise<CompleteApplicationDto>;

    /**
     * Get expenses overview in SOPP format for the applications with the provided ids.
    Content will depend on which status the authenticated users cluster has.
     * @param request Input parameters with list ApplicationIds. Required.
     */
    getApplicationsExpenseOverview(request: ApplicationIdList): Promise<SoppExpenseOverview>;

    /**
     * Gets a list of all activities on all applications belonging to the main application.
     */
    getCompleteActivitiesList(): Promise<PlannedActivity[]>;

    /**
     * Gets a complete Operation application based on operationApplicationId
     * @param operationApplicationId The identifier of the application. Use GET /api/application to get id for operation application.
     */
    getOperationApplication(operationApplicationId: string | null): Promise<OperationWithMetadataDto>;

    /**
     * Partially update operation application with id operationApplicationId. Include changes in request model.
    Other items will be unchanged.
     * @return When content is updated
     */
    partiallyUpdateOperation(operationApplicationId: string | null, request: OperationWithMetadataDto): Promise<void>;

    /**
     * Deletes the application with id operationApplicationId
     * @param operationApplicationId The identifier to delete
     * @return When application is deleted
     */
    deleteOperationApplication(operationApplicationId: string | null): Promise<void>;

    /**
     * Gets the operation application with operationApplicationId as HTML string
     * @param operationApplicationId The identifier of the application. Use GET /api/application to get id for operation application.
     */
    getOperationApplicationAsRawHtml(operationApplicationId: string | null): Promise<string>;

    /**
     * Gets the development application with developmentApplicationId as HTML string
     * @param developmentApplicationId The identifier of the application. Use GET /api/application to get the collection of development applications for current cluster
     */
    getDevelopmentApplicationAsRawHtml(developmentApplicationId: string | null): Promise<string>;

    /**
     * Gets the complete application with ids given by request as HTML string
     * @param request A list of identifiers of the applications.
     */
    getApplicationsAsRawHtml(request: ApplicationIdList): Promise<string>;

    /**
     * Gets the operation application with operationApplicationId as PDF file
     * @param operationApplicationId The identifier of the application. Use GET /api/application to get id for operation application.
     */
    getOperationApplicationAsPdf(operationApplicationId: string | null): Promise<FileResponse>;

    /**
     * Gets the development application with developmentApplicationId as PDF file
     * @param developmentApplicationId The identifier of the application. Use GET /api/application to get the collection of development applications for current cluster
     */
    getDevelopmentApplicationAsPdf(developmentApplicationId: string | null): Promise<FileResponse>;

    /**
     * Gets the complete application with ids given by request as PDF file
     * @param request A list of identifiers of the applications.
     */
    getApplicationsAsPdf(request: ApplicationIdList): Promise<FileResponse>;

    /**
     * Copy main application.
     * @return When appliction is copied successfully
     */
    copyCompleteApplication(oldProfileId: string, oldFormId: string | null): Promise<void>;

    /**
     * Creates a new operation application. 
    Will give 404 if main application does not exist
    Will give 409 conflict if one exists already.
     * @param request Input parameters with Title (1-200 characters). Required.
     * @return When appliction is created, returns id
     */
    createOperationApplication(request: TitleRequest): Promise<string>;

    /**
     * Creates a new development application with given title and type defined in request
     * @param request Input parameters title (1-200 characters) and type. Both are required.
     * @return When appliction is created, returns id
     */
    createDevelopmentApplication(request: CreateDevelopmentApplicationRequest): Promise<string>;

    /**
     * Partially update annual funding of main application with id mainApplicationId. Include changes in request model.
    Other items will be unchanged.
     * @return When content is updated
     */
    partiallyUpdateMainApplicationAnnualFunding(mainApplicationId: string | null, request: AnnualFundingApplicationFields): Promise<void>;

    /**
     * Update annual funding of main application with id mainApplicationId. Include changes in request model.
    Other items will be unchanged.
     * @param mainApplicationId id of main application
     * @param request The updated annual-funding info
     * @return When content is updated
     */
    updateMainApplicationAnnualFunding(mainApplicationId: string | null, request: AnnualFundingApplicationFields): Promise<void>;

    /**
     * Deletes the application with id developmentApplicationId
     * @param developmentApplicationId The identifier to delete
     * @return When application is deleted
     */
    deleteDevelopmentApplication(developmentApplicationId: string | null): Promise<void>;

    /**
     * Get all data for development application with id developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     */
    getDevelopmentApplication(developmentApplicationId: string | null): Promise<DevelopmentWithMetadataDto>;

    /**
     * Partially update the application with id developmentApplicationId, setting only data defined in request
    Other fields will be unchanged
     * @param developmentApplicationId Identifier of the application
     * @param request Data model to update
     * @return When content is updated
     */
    partiallyUpdateDevelopmentApplication(developmentApplicationId: string | null, request: DevelopmentWithMetadataDto): Promise<void>;

    /**
     * Deletes the applications with ids given in the body.
     * @return When applications are deleted
     */
    deleteDevelopmentApplications(request: ApplicationIdList): Promise<void>;

    /**
     * Validates the data of the operation application with id operationApplicationId
    Will give 422 unprocessable entity if validation error(s) occur.
     * @param operationApplicationId Identifier of the application
     */
    validateOperationApplication(operationApplicationId: string | null): Promise<void>;

    /**
     * Validates the data of the development application with id developmentApplicationId.
     * @param developmentApplicationId Identifier of the application
     */
    validateDevelopmentApplication(developmentApplicationId: string | null): Promise<void>;

    /**
     * Sets the operation application with id operationApplicationId to not ready to submit.
     * @param operationApplicationId Identifier of the application
     */
    setOperationApplicationReadyToSubmitToFalse(operationApplicationId: string | null): Promise<void>;

    /**
     * Sets the development application with id developmentApplicationId to not ready to submit.
     * @param developmentApplicationId Identifier of the application
     */
    setDevelopmentApplicationReadyToSubmitToFalse(developmentApplicationId: string | null): Promise<void>;

    /**
     * Submit sub applications with ids given in the body, as well as the main application. Any remaining sub applications will be transferred to a new main application.
     * @return When application submit is accepted and forwarded
     */
    submit(request: ApplicationIdList): Promise<void>;

    /**
     * Update the title of application with id developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param request Data model with title
     * @return When content is updated
     */
    updateDevelopmentApplicationTitle(developmentApplicationId: string | null, request: TitleRequest): Promise<void>;

    /**
     * Delete financing source financingSourceId of application operationApplicationId
     * @param operationApplicationId Identifier of application
     * @param financingSourceId Identifier of financing source to remove
     * @return When content is deleted
     */
    deleteOperationFinancingSource(operationApplicationId: string | null, financingSourceId: string): Promise<void>;

    /**
     * Delete financing source financingSourceId of application developmentApplicationId
     * @param developmentApplicationId Identifier of application
     * @param financingSourceId Identifier of financing source to remove
     * @return When content is deleted
     */
    deleteDevelopmentFinancingSource(developmentApplicationId: string | null, financingSourceId: string): Promise<void>;

    /**
     * Updates the activity with id activityId with data defined in activity of operation application operationApplicationId
     * @param operationApplicationId Identifier of the operation application
     * @param activityId Identifier of activity
     * @param activity Activity data
     * @return When content is deleted
     */
    updateOperationActivity(operationApplicationId: string | null, activityId: string, activity: OperationPlannedActivity): Promise<void>;

    /**
     * Delete activity activityId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param activityId Identifier of the activity
     * @return When content is deleted
     */
    deleteOperationActivity(operationApplicationId: string | null, activityId: string): Promise<void>;

    /**
     * Updates the activity with id activityId with data defined in activity of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the development application
     * @param activityId Identifier of activity
     * @param activity Activity data
     * @return When content is deleted
     */
    updateDevelopmentActivity(developmentApplicationId: string | null, activityId: string, activity: PlannedActivity): Promise<void>;

    /**
     * Delete activity activityId of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param activityId Identifier of the activity
     * @return When content is deleted
     */
    deleteDevelopmentActivity(developmentApplicationId: string | null, activityId: string): Promise<void>;

    /**
     * Updates the participants of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the operation application
     * @param participants Participants data
     * @return When content is updated
     */
    replaceDevelopmentParticipants(developmentApplicationId: string | null, participants: ClusterMember[]): Promise<void>;

    /**
     * Updates the BrReg participants of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the operation application
     * @param brRegParticipants Participants data
     * @return When content is updated
     */
    replaceDevelopmentBrRegParticipants(developmentApplicationId: string | null, brRegParticipants: BrRegMember[]): Promise<void>;

    updateDevelopmentCosts(developmentApplicationId: string | null, costs: Cost[]): Promise<void>;

    /**
     * Delete focus area focusAreaId of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param focusAreaId Identifier of the focus area
     * @return When content is deleted
     */
    deleteDevelopmentFocusArea(developmentApplicationId: string | null, focusAreaId: string): Promise<void>;

    /**
     * Delete focus area focusAreaId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param focusAreaId Identifier of the focus area
     * @return When content is deleted
     */
    deleteOperationFocusArea(operationApplicationId: string | null, focusAreaId: string): Promise<void>;

    /**
     * Delete the goal next year goalId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param goalId Identifier of goal
     * @return When content is deleted
     */
    deleteOperationGoalNextYear(operationApplicationId: string | null, goalId: string): Promise<void>;

    /**
     * Updates the goals of next year for application with operationApplicationId the be goals
    Removes the goals that are not present in goals
     * @param operationApplicationId ID of the application to update
     * @param goals The new list of goals
     * @return When content is deleted
     */
    updateOperationGoalsNextYear(operationApplicationId: string | null, goals: GoalNextYear[]): Promise<void>;

    /**
     * Updates the goals of this year for application with operationApplicationId the be focusAreas
    Removes the goals that are not present in focusAreas
     * @param operationApplicationId ID of the application to update
     * @param focusAreas The new list of goals
     * @return When content is deleted
     */
    updateOperationGoalsThisYear(operationApplicationId: string | null, focusAreas: GoalThisYear[]): Promise<void>;

    /**
     * Updates the focus areas for application with operationApplicationId the be focusAreas
    Removes the focus areas that are not present in focusAreas
     * @param operationApplicationId ID of the application to update
     * @param focusAreas The new list of focus areas
     * @return When content is deleted
     */
    updateOperationFocusAreas(operationApplicationId: string | null, focusAreas: FocusArea[]): Promise<void>;

    /**
     * Updates the social impacts of this year for application with operationApplicationId to be socialImpacts
    Removes the social impacts that are not present in socialImpacts
     * @param operationApplicationId ID of the application to update
     * @param socialImpacts The new list of social impacts
     * @return When content is deleted
     */
    updateOperationSocialImpacts(operationApplicationId: string | null, socialImpacts: SocialImpact[]): Promise<void>;

    /**
     * Updates the social impacts of this year for application with developmentApplicationId to be socialImpacts
    Removes the social impacts that are not present in socialImpacts
     * @param developmentApplicationId ID of the application to update
     * @param socialImpacts The new list of social impacts
     * @return When content is deleted
     */
    updateDevelopmentSocialImpacts(developmentApplicationId: string | null, socialImpacts: SocialImpact[]): Promise<void>;

    /**
     * Updates the focus areas for application with developmentApplicationId the be focusAreas
    Removes the focus areas that are not present in focusAreas
     * @param developmentApplicationId ID of the application to update
     * @param focusAreas Focus areas to update
     * @return When content is updated
     */
    updateDevelopmentFocusAreas(developmentApplicationId: string | null, focusAreas: FocusArea[]): Promise<void>;

    /**
     * Delete the goals of this year with id goalId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param goalId Identifier of goal
     * @return When content is deleted
     */
    deleteOperationGoalThisYear(operationApplicationId: string | null, goalId: string): Promise<void>;

    /**
     * Delete environmental impact impactId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param impactId Identifier of the impact
     * @return When content is deleted
     */
    deleteOperationSocietalEnvironmentalImpact(operationApplicationId: string | null, impactId: string | null): Promise<void>;

    /**
     * Delete environmental impact impactId of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param impactId Identifier of the impact
     * @return When content is deleted
     */
    deleteDevelopmentSocietalEnvironmentalImpact(developmentApplicationId: string | null, impactId: string | null): Promise<void>;
}

export class ApplicationsClient implements IApplicationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    resetCache(): Promise<void> {
        let url_ = this.baseUrl + "/api/reset-cache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetCache(_response);
        });
    }

    protected processResetCache(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMunicipalityCode(postalCode?: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/municipality-code?";
        if (postalCode !== undefined && postalCode !== null)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMunicipalityCode(_response);
        });
    }

    protected processGetMunicipalityCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets information related to creating new application (e.g. Objective and Type hierarchy for Development applications)
     */
    getApplicationCreationInformation(): Promise<ApplicationCreationInformation> {
        let url_ = this.baseUrl + "/api/application-creation-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicationCreationInformation(_response);
        });
    }

    protected processGetApplicationCreationInformation(response: Response): Promise<ApplicationCreationInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationCreationInformation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationCreationInformation>(null as any);
    }

    /**
     * Get updated cluster information from portal.
     */
    getUpdatedClusterInformation(): Promise<ClusterInformation> {
        let url_ = this.baseUrl + "/api/cluster-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUpdatedClusterInformation(_response);
        });
    }

    protected processGetUpdatedClusterInformation(response: Response): Promise<ClusterInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClusterInformation;
            return result200;
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to SL.Clusters", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClusterInformation>(null as any);
    }

    /**
     * Get "main" application which will contain an Operation application (if applicable) and a collection of development applications (if applicable).
    Content will depend on which status the authenticated users cluster has.
     */
    getApplicationOverview(): Promise<CompleteApplicationDto> {
        let url_ = this.baseUrl + "/api/application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicationOverview(_response);
        });
    }

    protected processGetApplicationOverview(response: Response): Promise<CompleteApplicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompleteApplicationDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there are multiple active main applications in Web Application for this cluster. There can only be one.", status, _responseText, _headers, result409);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When one of the sub applications referenced by the main application doesn\'t exist in Web Application for this cluster", status, _responseText, _headers, result410);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompleteApplicationDto>(null as any);
    }

    /**
     * Create a new main application.
     * @return When appliction is created
     */
    createCompleteApplication(): Promise<void> {
        let url_ = this.baseUrl + "/api/application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCompleteApplication(_response);
        });
    }

    protected processCreateCompleteApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s already a main application in Web Application for this cluster", status, _responseText, _headers, result409);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets a list of applications that are submitted for current cluster. 
    Only "Main" applications are listed, since they are combined into one application when passed on from WebApplication
     */
    getArchivedApplications(): Promise<SubmittedFormMetadata[]> {
        let url_ = this.baseUrl + "/api/applications/archive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArchivedApplications(_response);
        });
    }

    protected processGetArchivedApplications(response: Response): Promise<SubmittedFormMetadata[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmittedFormMetadata[];
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmittedFormMetadata[]>(null as any);
    }

    /**
     * Gets the actual PDF file which is the main application from ApplicationMaster
     * @param applicationId Id of the application in appid|accountId format
     * @return File result with contents
     */
    getArchivedApplicationAsPdf(applicationId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/applications/archive/{applicationId}/pdf";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArchivedApplicationAsPdf(_response);
        });
    }

    protected processGetArchivedApplicationAsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the actual DOCX file which is the main application from Archive system via ApplicationMaster
     * @param applicationId Id of the application in appid|accountId format
     * @return File result with contents
     */
    getArchivedApplicationAsDocx(applicationId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/applications/archive/{applicationId}/docx";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArchivedApplicationAsDocx(_response);
        });
    }

    protected processGetArchivedApplicationAsDocx(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get "main" application which will contain an Operation application (if applicable) and a collection of development applications (if applicable).
    If there are no existing applications, a main application, and an operation application if it should be there, will be created.
    Content will depend on which status the authenticated users cluster has.
     */
    createApplicationSetup(): Promise<CompleteApplicationDto> {
        let url_ = this.baseUrl + "/api/application-setup";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateApplicationSetup(_response);
        });
    }

    protected processCreateApplicationSetup(response: Response): Promise<CompleteApplicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompleteApplicationDto;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompleteApplicationDto;
            return result201;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there are multiple active main applications in Web Application for this cluster. There can only be one.", status, _responseText, _headers, result409);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When one of the sub applications referenced by the main application doesn\'t exist in Web Application for this cluster", status, _responseText, _headers, result410);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompleteApplicationDto>(null as any);
    }

    /**
     * Get expenses overview in SOPP format for the applications with the provided ids.
    Content will depend on which status the authenticated users cluster has.
     * @param request Input parameters with list ApplicationIds. Required.
     */
    getApplicationsExpenseOverview(request: ApplicationIdList): Promise<SoppExpenseOverview> {
        let url_ = this.baseUrl + "/api/application/expenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicationsExpenseOverview(_response);
        });
    }

    protected processGetApplicationsExpenseOverview(response: Response): Promise<SoppExpenseOverview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SoppExpenseOverview;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no application in Web Application for a provided id", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SoppExpenseOverview>(null as any);
    }

    /**
     * Gets a list of all activities on all applications belonging to the main application.
     */
    getCompleteActivitiesList(): Promise<PlannedActivity[]> {
        let url_ = this.baseUrl + "/api/applications/activities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompleteActivitiesList(_response);
        });
    }

    protected processGetCompleteActivitiesList(response: Response): Promise<PlannedActivity[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PlannedActivity[];
            return result200;
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivity[]>(null as any);
    }

    /**
     * Gets a complete Operation application based on operationApplicationId
     * @param operationApplicationId The identifier of the application. Use GET /api/application to get id for operation application.
     */
    getOperationApplication(operationApplicationId: string | null): Promise<OperationWithMetadataDto> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOperationApplication(_response);
        });
    }

    protected processGetOperationApplication(response: Response): Promise<OperationWithMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OperationWithMetadataDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OperationWithMetadataDto>(null as any);
    }

    /**
     * Partially update operation application with id operationApplicationId. Include changes in request model.
    Other items will be unchanged.
     * @return When content is updated
     */
    partiallyUpdateOperation(operationApplicationId: string | null, request: OperationWithMetadataDto): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartiallyUpdateOperation(_response);
        });
    }

    protected processPartiallyUpdateOperation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes the application with id operationApplicationId
     * @param operationApplicationId The identifier to delete
     * @return When application is deleted
     */
    deleteOperationApplication(operationApplicationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationApplication(_response);
        });
    }

    protected processDeleteOperationApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application or main application was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets the operation application with operationApplicationId as HTML string
     * @param operationApplicationId The identifier of the application. Use GET /api/application to get id for operation application.
     */
    getOperationApplicationAsRawHtml(operationApplicationId: string | null): Promise<string> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/html";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOperationApplicationAsRawHtml(_response);
        });
    }

    protected processGetOperationApplicationAsRawHtml(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no operation application in Web Application with the given id", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the development application with developmentApplicationId as HTML string
     * @param developmentApplicationId The identifier of the application. Use GET /api/application to get the collection of development applications for current cluster
     */
    getDevelopmentApplicationAsRawHtml(developmentApplicationId: string | null): Promise<string> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/html";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevelopmentApplicationAsRawHtml(_response);
        });
    }

    protected processGetDevelopmentApplicationAsRawHtml(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the complete application with ids given by request as HTML string
     * @param request A list of identifiers of the applications.
     */
    getApplicationsAsRawHtml(request: ApplicationIdList): Promise<string> {
        let url_ = this.baseUrl + "/api/applications/html";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicationsAsRawHtml(_response);
        });
    }

    protected processGetApplicationsAsRawHtml(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Gets the operation application with operationApplicationId as PDF file
     * @param operationApplicationId The identifier of the application. Use GET /api/application to get id for operation application.
     */
    getOperationApplicationAsPdf(operationApplicationId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/pdf";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOperationApplicationAsPdf(_response);
        });
    }

    protected processGetOperationApplicationAsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the development application with developmentApplicationId as PDF file
     * @param developmentApplicationId The identifier of the application. Use GET /api/application to get the collection of development applications for current cluster
     */
    getDevelopmentApplicationAsPdf(developmentApplicationId: string | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/pdf";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevelopmentApplicationAsPdf(_response);
        });
    }

    protected processGetDevelopmentApplicationAsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the complete application with ids given by request as PDF file
     * @param request A list of identifiers of the applications.
     */
    getApplicationsAsPdf(request: ApplicationIdList): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/applications/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicationsAsPdf(_response);
        });
    }

    protected processGetApplicationsAsPdf(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an application isn\'t found in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Copy main application.
     * @return When appliction is copied successfully
     */
    copyCompleteApplication(oldProfileId: string, oldFormId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/application/copy/{oldProfileId}/{oldFormId}";
        if (oldProfileId === undefined || oldProfileId === null)
            throw new Error("The parameter 'oldProfileId' must be defined.");
        url_ = url_.replace("{oldProfileId}", encodeURIComponent("" + oldProfileId));
        if (oldFormId === undefined || oldFormId === null)
            throw new Error("The parameter 'oldFormId' must be defined.");
        url_ = url_.replace("{oldFormId}", encodeURIComponent("" + oldFormId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCopyCompleteApplication(_response);
        });
    }

    protected processCopyCompleteApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new operation application. 
    Will give 404 if main application does not exist
    Will give 409 conflict if one exists already.
     * @param request Input parameters with Title (1-200 characters). Required.
     * @return When appliction is created, returns id
     */
    createOperationApplication(request: TitleRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/applications/operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOperationApplication(_response);
        });
    }

    protected processCreateOperationApplication(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid, e.g. Title is null/empty", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no main application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s already an operation application in Web Application for this cluster, or there are multiple active main applications", status, _responseText, _headers, result409);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When one of the sub applications referenced by the main application doesn\'t exist", status, _responseText, _headers, result410);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates a new development application with given title and type defined in request
     * @param request Input parameters title (1-200 characters) and type. Both are required.
     * @return When appliction is created, returns id
     */
    createDevelopmentApplication(request: CreateDevelopmentApplicationRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/applications/development";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDevelopmentApplication(_response);
        });
    }

    protected processCreateDevelopmentApplication(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid, e.g. Type or Title is null/empty", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application doesn\'t exist", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there are multiple active main applications", status, _responseText, _headers, result409);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When one of the sub applications referenced by the main application doesn\'t exist", status, _responseText, _headers, result410);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Partially update annual funding of main application with id mainApplicationId. Include changes in request model.
    Other items will be unchanged.
     * @return When content is updated
     */
    partiallyUpdateMainApplicationAnnualFunding(mainApplicationId: string | null, request: AnnualFundingApplicationFields): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/main/{mainApplicationId}/annual-funding";
        if (mainApplicationId === undefined || mainApplicationId === null)
            throw new Error("The parameter 'mainApplicationId' must be defined.");
        url_ = url_.replace("{mainApplicationId}", encodeURIComponent("" + mainApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartiallyUpdateMainApplicationAnnualFunding(_response);
        });
    }

    protected processPartiallyUpdateMainApplicationAnnualFunding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update annual funding of main application with id mainApplicationId. Include changes in request model.
    Other items will be unchanged.
     * @param mainApplicationId id of main application
     * @param request The updated annual-funding info
     * @return When content is updated
     */
    updateMainApplicationAnnualFunding(mainApplicationId: string | null, request: AnnualFundingApplicationFields): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/main/{mainApplicationId}/annual-funding";
        if (mainApplicationId === undefined || mainApplicationId === null)
            throw new Error("The parameter 'mainApplicationId' must be defined.");
        url_ = url_.replace("{mainApplicationId}", encodeURIComponent("" + mainApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMainApplicationAnnualFunding(_response);
        });
    }

    protected processUpdateMainApplicationAnnualFunding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When there\'s no application in Web Application for this cluster", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes the application with id developmentApplicationId
     * @param developmentApplicationId The identifier to delete
     * @return When application is deleted
     */
    deleteDevelopmentApplication(developmentApplicationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevelopmentApplication(_response);
        });
    }

    protected processDeleteDevelopmentApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application or main application was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get all data for development application with id developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     */
    getDevelopmentApplication(developmentApplicationId: string | null): Promise<DevelopmentWithMetadataDto> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevelopmentApplication(_response);
        });
    }

    protected processGetDevelopmentApplication(response: Response): Promise<DevelopmentWithMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DevelopmentWithMetadataDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DevelopmentWithMetadataDto>(null as any);
    }

    /**
     * Partially update the application with id developmentApplicationId, setting only data defined in request
    Other fields will be unchanged
     * @param developmentApplicationId Identifier of the application
     * @param request Data model to update
     * @return When content is updated
     */
    partiallyUpdateDevelopmentApplication(developmentApplicationId: string | null, request: DevelopmentWithMetadataDto): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartiallyUpdateDevelopmentApplication(_response);
        });
    }

    protected processPartiallyUpdateDevelopmentApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes the applications with ids given in the body.
     * @return When applications are deleted
     */
    deleteDevelopmentApplications(request: ApplicationIdList): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevelopmentApplications(_response);
        });
    }

    protected processDeleteDevelopmentApplications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application or main application was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Validates the data of the operation application with id operationApplicationId
    Will give 422 unprocessable entity if validation error(s) occur.
     * @param operationApplicationId Identifier of the application
     */
    validateOperationApplication(operationApplicationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/validation-result";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateOperationApplication(_response);
        });
    }

    protected processValidateOperationApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application is not found", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("If validation fails for the application", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Validates the data of the development application with id developmentApplicationId.
     * @param developmentApplicationId Identifier of the application
     */
    validateDevelopmentApplication(developmentApplicationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/validation-result";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateDevelopmentApplication(_response);
        });
    }

    protected processValidateDevelopmentApplication(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application is not found", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("If validation fails for the application", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets the operation application with id operationApplicationId to not ready to submit.
     * @param operationApplicationId Identifier of the application
     */
    setOperationApplicationReadyToSubmitToFalse(operationApplicationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/application/operation/{operationApplicationId}/ready-to-submit-false";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetOperationApplicationReadyToSubmitToFalse(_response);
        });
    }

    protected processSetOperationApplicationReadyToSubmitToFalse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When main application is not found or main application does not have an operation application with the given id", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets the development application with id developmentApplicationId to not ready to submit.
     * @param developmentApplicationId Identifier of the application
     */
    setDevelopmentApplicationReadyToSubmitToFalse(developmentApplicationId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/application/development/{developmentApplicationId}/ready-to-submit-false";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDevelopmentApplicationReadyToSubmitToFalse(_response);
        });
    }

    protected processSetDevelopmentApplicationReadyToSubmitToFalse(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When main application is not found or main application does not have an development application with the given id", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Submit sub applications with ids given in the body, as well as the main application. Any remaining sub applications will be transferred to a new main application.
     * @return When application submit is accepted and forwarded
     */
    submit(request: ApplicationIdList): Promise<void> {
        let url_ = this.baseUrl + "/api/application/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("When main application has no sub applications", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When application was not found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an operations application exists, but was not included in the list of ids.", status, _responseText, _headers, result409);
            });
        } else if (status === 417) {
            return response.text().then((_responseText) => {
            let result417: any = null;
            result417 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Submit of an annual funding application is not allowed at this time, or postal code has invalid format", status, _responseText, _headers, result417);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("If validation fails for the application", status, _responseText, _headers, result422);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Submit is not allowed at this time", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the title of application with id developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param request Data model with title
     * @return When content is updated
     */
    updateDevelopmentApplicationTitle(developmentApplicationId: string | null, request: TitleRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/title";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDevelopmentApplicationTitle(_response);
        });
    }

    protected processUpdateDevelopmentApplicationTitle(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When input is invalid", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application or its main application don\'t exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete financing source financingSourceId of application operationApplicationId
     * @param operationApplicationId Identifier of application
     * @param financingSourceId Identifier of financing source to remove
     * @return When content is deleted
     */
    deleteOperationFinancingSource(operationApplicationId: string | null, financingSourceId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/financing-sources/{financingSourceId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (financingSourceId === undefined || financingSourceId === null)
            throw new Error("The parameter 'financingSourceId' must be defined.");
        url_ = url_.replace("{financingSourceId}", encodeURIComponent("" + financingSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationFinancingSource(_response);
        });
    }

    protected processDeleteOperationFinancingSource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application or financing source does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete financing source financingSourceId of application developmentApplicationId
     * @param developmentApplicationId Identifier of application
     * @param financingSourceId Identifier of financing source to remove
     * @return When content is deleted
     */
    deleteDevelopmentFinancingSource(developmentApplicationId: string | null, financingSourceId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/financing-sources/{financingSourceId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        if (financingSourceId === undefined || financingSourceId === null)
            throw new Error("The parameter 'financingSourceId' must be defined.");
        url_ = url_.replace("{financingSourceId}", encodeURIComponent("" + financingSourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevelopmentFinancingSource(_response);
        });
    }

    protected processDeleteDevelopmentFinancingSource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the activity with id activityId with data defined in activity of operation application operationApplicationId
     * @param operationApplicationId Identifier of the operation application
     * @param activityId Identifier of activity
     * @param activity Activity data
     * @return When content is deleted
     */
    updateOperationActivity(operationApplicationId: string | null, activityId: string, activity: OperationPlannedActivity): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/activities/{activityId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOperationActivity(_response);
        });
    }

    protected processUpdateOperationActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete activity activityId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param activityId Identifier of the activity
     * @return When content is deleted
     */
    deleteOperationActivity(operationApplicationId: string | null, activityId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/activities/{activityId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationActivity(_response);
        });
    }

    protected processDeleteOperationActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the activity with id activityId with data defined in activity of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the development application
     * @param activityId Identifier of activity
     * @param activity Activity data
     * @return When content is deleted
     */
    updateDevelopmentActivity(developmentApplicationId: string | null, activityId: string, activity: PlannedActivity): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/activities/{activityId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDevelopmentActivity(_response);
        });
    }

    protected processUpdateDevelopmentActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete activity activityId of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param activityId Identifier of the activity
     * @return When content is deleted
     */
    deleteDevelopmentActivity(developmentApplicationId: string | null, activityId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/activities/{activityId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevelopmentActivity(_response);
        });
    }

    protected processDeleteDevelopmentActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the participants of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the operation application
     * @param participants Participants data
     * @return When content is updated
     */
    replaceDevelopmentParticipants(developmentApplicationId: string | null, participants: ClusterMember[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/participants";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(participants);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReplaceDevelopmentParticipants(_response);
        });
    }

    protected processReplaceDevelopmentParticipants(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the BrReg participants of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the operation application
     * @param brRegParticipants Participants data
     * @return When content is updated
     */
    replaceDevelopmentBrRegParticipants(developmentApplicationId: string | null, brRegParticipants: BrRegMember[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/brreg-participants";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(brRegParticipants);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReplaceDevelopmentBrRegParticipants(_response);
        });
    }

    protected processReplaceDevelopmentBrRegParticipants(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDevelopmentCosts(developmentApplicationId: string | null, costs: Cost[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/costs";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(costs);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDevelopmentCosts(_response);
        });
    }

    protected processUpdateDevelopmentCosts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete focus area focusAreaId of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param focusAreaId Identifier of the focus area
     * @return When content is deleted
     */
    deleteDevelopmentFocusArea(developmentApplicationId: string | null, focusAreaId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/focus-areas/{focusAreaId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevelopmentFocusArea(_response);
        });
    }

    protected processDeleteDevelopmentFocusArea(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete focus area focusAreaId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param focusAreaId Identifier of the focus area
     * @return When content is deleted
     */
    deleteOperationFocusArea(operationApplicationId: string | null, focusAreaId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/focus-areas/{focusAreaId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (focusAreaId === undefined || focusAreaId === null)
            throw new Error("The parameter 'focusAreaId' must be defined.");
        url_ = url_.replace("{focusAreaId}", encodeURIComponent("" + focusAreaId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationFocusArea(_response);
        });
    }

    protected processDeleteOperationFocusArea(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the goal next year goalId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param goalId Identifier of goal
     * @return When content is deleted
     */
    deleteOperationGoalNextYear(operationApplicationId: string | null, goalId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/goals-next-year/{goalId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationGoalNextYear(_response);
        });
    }

    protected processDeleteOperationGoalNextYear(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the goals of next year for application with operationApplicationId the be goals
    Removes the goals that are not present in goals
     * @param operationApplicationId ID of the application to update
     * @param goals The new list of goals
     * @return When content is deleted
     */
    updateOperationGoalsNextYear(operationApplicationId: string | null, goals: GoalNextYear[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/goals-next-year";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(goals);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOperationGoalsNextYear(_response);
        });
    }

    protected processUpdateOperationGoalsNextYear(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the goals of this year for application with operationApplicationId the be focusAreas
    Removes the goals that are not present in focusAreas
     * @param operationApplicationId ID of the application to update
     * @param focusAreas The new list of goals
     * @return When content is deleted
     */
    updateOperationGoalsThisYear(operationApplicationId: string | null, focusAreas: GoalThisYear[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/goals-this-year";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(focusAreas);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOperationGoalsThisYear(_response);
        });
    }

    protected processUpdateOperationGoalsThisYear(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the focus areas for application with operationApplicationId the be focusAreas
    Removes the focus areas that are not present in focusAreas
     * @param operationApplicationId ID of the application to update
     * @param focusAreas The new list of focus areas
     * @return When content is deleted
     */
    updateOperationFocusAreas(operationApplicationId: string | null, focusAreas: FocusArea[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/focus-areas";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(focusAreas);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOperationFocusAreas(_response);
        });
    }

    protected processUpdateOperationFocusAreas(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the social impacts of this year for application with operationApplicationId to be socialImpacts
    Removes the social impacts that are not present in socialImpacts
     * @param operationApplicationId ID of the application to update
     * @param socialImpacts The new list of social impacts
     * @return When content is deleted
     */
    updateOperationSocialImpacts(operationApplicationId: string | null, socialImpacts: SocialImpact[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/social-impacts";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(socialImpacts);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOperationSocialImpacts(_response);
        });
    }

    protected processUpdateOperationSocialImpacts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the social impacts of this year for application with developmentApplicationId to be socialImpacts
    Removes the social impacts that are not present in socialImpacts
     * @param developmentApplicationId ID of the application to update
     * @param socialImpacts The new list of social impacts
     * @return When content is deleted
     */
    updateDevelopmentSocialImpacts(developmentApplicationId: string | null, socialImpacts: SocialImpact[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/social-impacts";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(socialImpacts);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDevelopmentSocialImpacts(_response);
        });
    }

    protected processUpdateDevelopmentSocialImpacts(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the focus areas for application with developmentApplicationId the be focusAreas
    Removes the focus areas that are not present in focusAreas
     * @param developmentApplicationId ID of the application to update
     * @param focusAreas Focus areas to update
     * @return When content is updated
     */
    updateDevelopmentFocusAreas(developmentApplicationId: string | null, focusAreas: FocusArea[]): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/focus-areas";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(focusAreas);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDevelopmentFocusAreas(_response);
        });
    }

    protected processUpdateDevelopmentFocusAreas(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete the goals of this year with id goalId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param goalId Identifier of goal
     * @return When content is deleted
     */
    deleteOperationGoalThisYear(operationApplicationId: string | null, goalId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/goals-this-year/{goalId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationGoalThisYear(_response);
        });
    }

    protected processDeleteOperationGoalThisYear(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete environmental impact impactId of operation application operationApplicationId
     * @param operationApplicationId Identifier of the application
     * @param impactId Identifier of the impact
     * @return When content is deleted
     */
    deleteOperationSocietalEnvironmentalImpact(operationApplicationId: string | null, impactId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/operation/{operationApplicationId}/societal-environmental-impacts/{impactId}";
        if (operationApplicationId === undefined || operationApplicationId === null)
            throw new Error("The parameter 'operationApplicationId' must be defined.");
        url_ = url_.replace("{operationApplicationId}", encodeURIComponent("" + operationApplicationId));
        if (impactId === undefined || impactId === null)
            throw new Error("The parameter 'impactId' must be defined.");
        url_ = url_.replace("{impactId}", encodeURIComponent("" + impactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOperationSocietalEnvironmentalImpact(_response);
        });
    }

    protected processDeleteOperationSocietalEnvironmentalImpact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Delete environmental impact impactId of development application developmentApplicationId
     * @param developmentApplicationId Identifier of the application
     * @param impactId Identifier of the impact
     * @return When content is deleted
     */
    deleteDevelopmentSocietalEnvironmentalImpact(developmentApplicationId: string | null, impactId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/development/{developmentApplicationId}/societal-environmental-impacts/{impactId}";
        if (developmentApplicationId === undefined || developmentApplicationId === null)
            throw new Error("The parameter 'developmentApplicationId' must be defined.");
        url_ = url_.replace("{developmentApplicationId}", encodeURIComponent("" + developmentApplicationId));
        if (impactId === undefined || impactId === null)
            throw new Error("The parameter 'impactId' must be defined.");
        url_ = url_.replace("{impactId}", encodeURIComponent("" + impactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDevelopmentSocietalEnvironmentalImpact(_response);
        });
    }

    protected processDeleteDevelopmentSocietalEnvironmentalImpact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the application does not exist", status, _responseText, _headers, result404);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When the focus area is in use by at least one activity or the main application is locked (e.g. in submit process)", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("When an error occurs in requests to Web Application", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAttachmentsClient {

    get(applicationId: string | null, attachmentId: string | null): Promise<void>;

    delete(applicationId: string | null, attachmentId: string | null): Promise<void>;

    create(applicationId: string | null, fieldName?: string | null | undefined, fileNamePrefix?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Attachment>;
}

export class AttachmentsClient implements IAttachmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(applicationId: string | null, attachmentId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/{applicationId}/attachments/{attachmentId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(applicationId: string | null, attachmentId: string | null): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/{applicationId}/attachments/{attachmentId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    create(applicationId: string | null, fieldName?: string | null | undefined, fileNamePrefix?: string | null | undefined, file?: FileParameter | null | undefined): Promise<Attachment> {
        let url_ = this.baseUrl + "/api/applications/{applicationId}/attachments";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fieldName !== null && fieldName !== undefined)
            content_.append("FieldName", fieldName.toString());
        if (fileNamePrefix !== null && fileNamePrefix !== undefined)
            content_.append("FileNamePrefix", fileNamePrefix.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Attachment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Attachment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Attachment>(null as any);
    }
}

export interface IChoicesClient {

    getClusterManagementContactRoles(): Promise<LabelValueDto[]>;

    getMemberCategories(): Promise<LabelValueDto[]>;

    getMemberTypes(): Promise<LabelValueDto[]>;

    getClusterExpenseTypes(): Promise<LabelValueDto[]>;

    getClusterExpenseTypesByApplicationType(applicationType?: string | null | undefined): Promise<LabelValueDto[]>;

    getInnovationLevels(): Promise<LabelValueDto[]>;

    getSocietalEffects(): Promise<LabelValueDto[]>;

    getFinancingSources(): Promise<LabelValueDto[]>;

    getApplicationTypes(): Promise<LabelValueDto[]>;
}

export class ChoicesClient implements IChoicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getClusterManagementContactRoles(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/GetClusterManagementContactRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClusterManagementContactRoles(_response);
        });
    }

    protected processGetClusterManagementContactRoles(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getMemberCategories(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/GetMemberCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberCategories(_response);
        });
    }

    protected processGetMemberCategories(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getMemberTypes(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/GetMemberTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMemberTypes(_response);
        });
    }

    protected processGetMemberTypes(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getClusterExpenseTypes(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/expense-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClusterExpenseTypes(_response);
        });
    }

    protected processGetClusterExpenseTypes(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getClusterExpenseTypesByApplicationType(applicationType?: string | null | undefined): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/expense-types-by-application-type?";
        if (applicationType !== undefined && applicationType !== null)
            url_ += "applicationType=" + encodeURIComponent("" + applicationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClusterExpenseTypesByApplicationType(_response);
        });
    }

    protected processGetClusterExpenseTypesByApplicationType(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getInnovationLevels(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/innovation-levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInnovationLevels(_response);
        });
    }

    protected processGetInnovationLevels(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getSocietalEffects(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/societal-effects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSocietalEffects(_response);
        });
    }

    protected processGetSocietalEffects(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getFinancingSources(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/financing-sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancingSources(_response);
        });
    }

    protected processGetFinancingSources(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }

    getApplicationTypes(): Promise<LabelValueDto[]> {
        let url_ = this.baseUrl + "/api/Choices/application-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicationTypes(_response);
        });
    }

    protected processGetApplicationTypes(response: Response): Promise<LabelValueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LabelValueDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LabelValueDto[]>(null as any);
    }
}

export interface IClusterMembersClient {

    getActiveClusterMembers(): Promise<ClusterMember[]>;
}

export class ClusterMembersClient implements IClusterMembersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getActiveClusterMembers(): Promise<ClusterMember[]> {
        let url_ = this.baseUrl + "/api/ClusterMembers/GetActiveClusterMembers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActiveClusterMembers(_response);
        });
    }

    protected processGetActiveClusterMembers(response: Response): Promise<ClusterMember[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClusterMember[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClusterMember[]>(null as any);
    }
}

export interface IClustersClient {

    getMyCluster(): Promise<ClusterInfoForApplicationDto>;

    getMyClusterV2(): Promise<ClusterDto>;

    getMyClusters(): Promise<ClusterDto[]>;

    getMyClusterInformation(): Promise<ClusterInformation>;

    getFocusAreas(): Promise<FocusArea[]>;

    getMainGoals(): Promise<Goal[]>;

    /**
     * Gets financial frame for the cluster.
     */
    getMyClusterFinancialFrame(): Promise<ApplicationFinancialFrameDto>;
}

export class ClustersClient implements IClustersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getMyCluster(): Promise<ClusterInfoForApplicationDto> {
        let url_ = this.baseUrl + "/api/Clusters/GetMyCluster";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyCluster(_response);
        });
    }

    protected processGetMyCluster(response: Response): Promise<ClusterInfoForApplicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClusterInfoForApplicationDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClusterInfoForApplicationDto>(null as any);
    }

    getMyClusterV2(): Promise<ClusterDto> {
        let url_ = this.baseUrl + "/api/Clusters/GetMyClusterV2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyClusterV2(_response);
        });
    }

    protected processGetMyClusterV2(response: Response): Promise<ClusterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClusterDto>(null as any);
    }

    getMyClusters(): Promise<ClusterDto[]> {
        let url_ = this.baseUrl + "/api/Clusters/mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyClusters(_response);
        });
    }

    protected processGetMyClusters(response: Response): Promise<ClusterDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClusterDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClusterDto[]>(null as any);
    }

    getMyClusterInformation(): Promise<ClusterInformation> {
        let url_ = this.baseUrl + "/api/Clusters/GetMyClusterInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyClusterInformation(_response);
        });
    }

    protected processGetMyClusterInformation(response: Response): Promise<ClusterInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClusterInformation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClusterInformation>(null as any);
    }

    getFocusAreas(): Promise<FocusArea[]> {
        let url_ = this.baseUrl + "/api/Clusters/focus-areas";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFocusAreas(_response);
        });
    }

    protected processGetFocusAreas(response: Response): Promise<FocusArea[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FocusArea[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FocusArea[]>(null as any);
    }

    getMainGoals(): Promise<Goal[]> {
        let url_ = this.baseUrl + "/api/Clusters/main-goals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMainGoals(_response);
        });
    }

    protected processGetMainGoals(response: Response): Promise<Goal[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Goal[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Goal[]>(null as any);
    }

    /**
     * Gets financial frame for the cluster.
     */
    getMyClusterFinancialFrame(): Promise<ApplicationFinancialFrameDto> {
        let url_ = this.baseUrl + "/api/Clusters/financial-frame";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyClusterFinancialFrame(_response);
        });
    }

    protected processGetMyClusterFinancialFrame(response: Response): Promise<ApplicationFinancialFrameDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplicationFinancialFrameDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationFinancialFrameDto>(null as any);
    }
}

export interface IConfigurationClient {

    /**
     * Gets information about the current environment (dev, test or prod)
     * @return Environment information
     */
    getEnvironmentInformation(): Promise<EnvironmentInformation>;
}

export class ConfigurationClient implements IConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets information about the current environment (dev, test or prod)
     * @return Environment information
     */
    getEnvironmentInformation(): Promise<EnvironmentInformation> {
        let url_ = this.baseUrl + "/api/configuration/environment-information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEnvironmentInformation(_response);
        });
    }

    protected processGetEnvironmentInformation(response: Response): Promise<EnvironmentInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EnvironmentInformation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnvironmentInformation>(null as any);
    }
}

export interface ISessionClient {

    login(domainHint?: string | null | undefined): Promise<FileResponse>;

    /**
     * Gets current user name
     * @return User name
     */
    getCurrent(): Promise<UserDto>;

    signOut(): Promise<FileResponse>;

    singleLogOut(): Promise<FileResponse>;

    storeChosenCluster(clusterId: string): Promise<UserDto>;

    deleteChosenCluster(): Promise<void>;
}

export class SessionClient implements ISessionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    login(domainHint?: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Session/login?";
        if (domainHint !== undefined && domainHint !== null)
            url_ += "domainHint=" + encodeURIComponent("" + domainHint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets current user name
     * @return User name
     */
    getCurrent(): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Session/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrent(_response);
        });
    }

    protected processGetCurrent(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    signOut(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/sign-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignOut(_response);
        });
    }

    protected processSignOut(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    singleLogOut(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/single-log-out";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSingleLogOut(_response);
        });
    }

    protected processSingleLogOut(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    storeChosenCluster(clusterId: string): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Session/clusterId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(clusterId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStoreChosenCluster(_response);
        });
    }

    protected processStoreChosenCluster(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    deleteChosenCluster(): Promise<void> {
        let url_ = this.baseUrl + "/api/Session/clusterId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteChosenCluster(_response);
        });
    }

    protected processDeleteChosenCluster(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserClient {

    getUser(userId: string): Promise<UserDto2>;

    getUserByB2CId(): Promise<UserDto2>;

    getUserRolePermissions(clusterId: string): Promise<PermissionDtoV2>;
}

export class UserClient implements IUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUser(userId: string): Promise<UserDto2> {
        let url_ = this.baseUrl + "/api/User/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto2;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto2>(null as any);
    }

    getUserByB2CId(): Promise<UserDto2> {
        let url_ = this.baseUrl + "/api/User/GetUserByB2CId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserByB2CId(_response);
        });
    }

    protected processGetUserByB2CId(response: Response): Promise<UserDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDto2;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto2>(null as any);
    }

    getUserRolePermissions(clusterId: string): Promise<PermissionDtoV2> {
        let url_ = this.baseUrl + "/api/User/role-permissions/{clusterId}";
        if (clusterId === undefined || clusterId === null)
            throw new Error("The parameter 'clusterId' must be defined.");
        url_ = url_.replace("{clusterId}", encodeURIComponent("" + clusterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserRolePermissions(_response);
        });
    }

    protected processGetUserRolePermissions(response: Response): Promise<PermissionDtoV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PermissionDtoV2;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionDtoV2>(null as any);
    }
}

export interface ProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export interface ApplicationCreationInformation {
    operation: OperationCreationInformation | undefined;
    development: DevelopmentCreationInformation | undefined;
}

export interface OperationCreationInformation {
    header: string | undefined;
    ingress: string | undefined;
    title: string | undefined;
    description: string | undefined;
}

export interface DevelopmentCreationInformation {
    header: string | undefined;
    ingress: string | undefined;
    objectives: ObjectivesCreationInformation[] | undefined;
}

export interface ObjectivesCreationInformation {
    title: string | undefined;
    description: string | undefined;
    readMore: string | undefined;
    comment: string | undefined;
    types: LabelValueDto[] | undefined;
}

export interface LabelValueDto {
    label: string | undefined;
    value: string | undefined;
}

export interface ClusterInformation {
    keyInformation: ClusterKeyInformation | undefined;
    management: ClusterManagement | undefined;
    board: ClusterBoard | undefined;
}

export interface ClusterKeyInformation {
    id: string;
    name: string | undefined;
    clusterOwnerOrgNumber: string | undefined;
    clusterStatus: ClusterStatusEnum;
    address: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    municipality: string | undefined;
    industryCode: string | undefined;
    purpose: string | undefined;
    vision: string | undefined;
    membersCount: number;
    clusterAdvisorId: string | undefined;
}

export enum ClusterStatusEnum {
    Arena = "Arena",
    ArenaPro = "ArenaPro",
    NCE = "NCE",
    GCE = "GCE",
    ModneKlynger = "ModneKlynger",
    ClusterInitiative = "ClusterInitiative",
    BusinessNetwork = "BusinessNetwork",
    Network = "Network",
    OneWayInActor = "OneWayInActor",
    NotSet = "NotSet",
}

export interface ClusterManagement {
    contacts: ClusterManagementContact[] | undefined;
    femaleCount: number;
    maleCount: number;
}

export interface ClusterManagementContact {
    id: string;
    name: string | undefined;
    role: string | undefined;
    clusterMember: string | undefined;
}

export interface ClusterBoard {
    members: ClusterBoardMember[] | undefined;
    femaleCount: number;
    maleCount: number;
}

export interface ClusterBoardMember {
    id: string;
    name: string | undefined;
    role: string | undefined;
    clusterMember: string | undefined;
    organizationNumber: string | undefined;
}

/** Serves as a base class for application models. Added as constraint for generic transformer. */
export interface ApplicationWithMetadata {
    metadata: ApplicationMetadata | undefined;
    attachments: Attachment[] | undefined;
}

export interface CompleteApplicationDto extends ApplicationWithMetadata {
    id: string | undefined;
    title: string | undefined;
    convertedToV2: boolean | undefined;
    clusterInformation: ClusterInformation | undefined;
    submitInformation: SubmitInformation | undefined;
    annualFunding: AnnualFundingApplicationFields | undefined;
    operationsApplication: OperationApplicationOverviewDto | undefined;
    developmentApplications: DevelopmentApplicationOverviewDto[] | undefined;
}

export interface SubmitInformation {
    year: number;
    isAnnualFundingApplication: boolean;
    matureClusterPeriodEndDate: string | undefined;
    operationsGrantsAlreadyAppliedFor: number | undefined;
    developmentGrantsAlreadyAppliedFor: number | undefined;
}

export interface AnnualFundingApplicationFields {
    goodBusinessPracticeConsent: boolean | undefined;
    clusterOrganizationComments: string | undefined;
    resourceBaseComments: string | undefined;
}

export interface OperationApplicationOverviewDto extends ApplicationWithMetadata {
    id: string | undefined;
    title: string | undefined;
    applicationId: string | undefined;
    readyToSubmit: boolean | undefined;
    appliedForFunds: number | undefined;
}

export interface ApplicationMetadata {
    createdBy: string | undefined;
    createdOn: string | undefined;
    language: Language;
    projectMunicipality: string | undefined;
    submitted: boolean | undefined;
    submittedOn: string | undefined;
    submittedBy: string | undefined;
    state: string | undefined;
    status: string | undefined;
    modifiedBy: string | undefined;
    modifiedOn: string | undefined;
}

export enum Language {
    En_GB = "en_GB",
    Nb_NO = "nb_NO",
    Nn_NO = "nn_NO",
}

export interface Attachment {
    contentType: string | undefined;
    uploadName: string | undefined;
    name: string | undefined;
    uploadTime: string | undefined;
    length: number | undefined;
}

export interface DevelopmentApplicationOverviewDto extends ApplicationWithMetadata {
    id: string | undefined;
    title: string | undefined;
    readyToSubmit: boolean | undefined;
    objective: string | undefined;
    typeLabel: string | undefined;
    type: ProjectApplicationTypeEnum | undefined;
    appliedForFunds: number | undefined;
}

export enum ProjectApplicationTypeEnum {
    Training = "Training",
    EducationalOperations = "EducationalOperations",
    FeasibilityStudy = "FeasibilityStudy",
    InnovationCooperation = "InnovationCooperation",
    InnovationCounseling = "InnovationCounseling",
    Investments = "Investments",
    ConferenceParticipation = "ConferenceParticipation",
    InternationalMarketsKnowledge = "InternationalMarketsKnowledge",
    InternationalMarketPositionsDevelopment = "InternationalMarketPositionsDevelopment",
    OperationApplication = "OperationApplication",
    Announcement = "Announcement",
}

export interface SubmittedFormMetadata {
    id: string | undefined;
    title: string | undefined;
    status: string | undefined;
    modifiedOn: string;
}

export interface SoppExpenseOverview {
    description: string | undefined;
    expenseCategories: SoppExpenseCategory[] | undefined;
}

export interface SoppExpenseCategory {
    id: string;
    expenseCategory: string | undefined;
    description: string | undefined;
    costs: SoppCost[] | undefined;
}

export interface SoppCost {
    id: string;
    name: string | undefined;
    applicantAmount: number;
    participantsAmount: number;
}

export interface ApplicationIdList {
    applicationIds: string[] | undefined;
}

export interface PlannedActivity {
    id: string;
    name: string | undefined;
    description: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    costComments: string | undefined;
    costs: Cost[] | undefined;
}

export interface Cost {
    id: string;
    type: string | undefined;
    name: string | undefined;
    applicantAmount: number | undefined;
    participantsAmount: number | undefined;
}

export interface OperationApplicationDto {
    id: string | undefined;
    title: string | undefined;
    activitiesNotStarted: boolean | undefined;
    activity: ApplicationActivity | undefined;
    impact: SocietalEnvironmentalImpact | undefined;
    financing: FinancingPlan | undefined;
    extraComments: string | undefined;
}

export interface OperationWithMetadataDto extends OperationApplicationDto {
    metadata: ApplicationMetadata | undefined;
    attachments: Attachment[] | undefined;
}

export interface ApplicationActivity {
    goalsThisYear: GoalThisYear[] | undefined;
    goalsNextYear: GoalNextYear[] | undefined;
    focusAreasNextYear: FocusArea[] | undefined;
    resultsDescription: string | undefined;
    plannedActivitiesOverallDescription: string | undefined;
    plannedActivities: OperationPlannedActivity[] | undefined;
}

export interface Goal {
    id: string;
    name: string | undefined;
}

export interface GoalThisYear extends Goal {
    activitiesForAchieving: string | undefined;
    achievementComments: string | undefined;
}

export interface GoalNextYear extends Goal {
    description: string | undefined;
}

export interface FocusArea {
    id: string;
    name: string | undefined;
    description: string | undefined;
}

export interface OperationPlannedActivity extends PlannedActivity {
    goalDescription: string | undefined;
    mainGoalId: string;
    focusAreaIds: string[] | undefined;
}

export interface SocietalEnvironmentalImpact {
    notApplicable: boolean | undefined;
    notApplicableComment: string | undefined;
    impacts: SocialImpact[] | undefined;
}

export interface SocialImpact {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
}

export interface FinancingPlan {
    sources: FinancingSource[] | undefined;
    comments: string | undefined;
}

export interface FinancingSource {
    id: string;
    type: string | undefined;
    name: string | undefined;
    amount: number | undefined;
}

export interface TitleRequest {
    title: string | undefined;
}

export interface CreateDevelopmentApplicationRequest {
    title: string | undefined;
    type: ProjectApplicationTypeEnum | undefined;
    /** Confirming that the activities in the development project that is being applied for is indeed not started at the time of application. */
    projectStarted: boolean | undefined;
}

export interface DevelopmentApplicationDto {
    id: string | undefined;
    title: string | undefined;
    objective: string | undefined;
    typeLabel: string | undefined;
    type: ProjectApplicationTypeEnum | undefined;
    project: ProjectInformation | undefined;
    plannedActivities: PlannedActivity[] | undefined;
    impact: SocietalEnvironmentalImpact | undefined;
    financing: FinancingPlan | undefined;
    costs: Cost[] | undefined;
    extraComments: string | undefined;
}

export interface DevelopmentWithMetadataDto extends DevelopmentApplicationDto {
    metadata: ApplicationMetadata | undefined;
    attachments: Attachment[] | undefined;
}

export interface ProjectInformation {
    projectStarted: boolean | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    goal: Goal | undefined;
    focusAreas: FocusArea[] | undefined;
    projectJustification: string | undefined;
    goalDescription: string | undefined;
    applicationTypeSpecificInformation: ApplicationTypeSpecificInformation | undefined;
    participants: ProjectParticipants | undefined;
}

export interface ApplicationTypeSpecificInformation {
    trainingDescription: string | undefined;
    educationalOfferingsDescription: string | undefined;
    feasibilityStudyInnovationLevel: string | undefined;
    futureClusterValueDescription: string | undefined;
}

export interface ProjectParticipants {
    participantsDescription: string | undefined;
    participants: ClusterMember[] | undefined;
    brRegParticipants: BrRegMember[] | undefined;
}

export interface ClusterMember {
    id: string;
    name: string | undefined;
}

export interface BrRegMember {
    id: string | undefined;
    name: string | undefined;
}

export interface ClusterInfoForApplicationDto {
    id: string;
    name: string | undefined;
    emailAddress: string | undefined;
    telephone: string | undefined;
    websiteUrl: string | undefined;
    clusterOwner: string | undefined;
    clusterOwnerOrgNumber: string | undefined;
    organizationNumber: string | undefined;
    street: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    county: string | undefined;
    address: AddressDto | undefined;
    industryCode: string | undefined;
    clusterPurpose: string | undefined;
    clusterVision: string | undefined;
    inCrmAccountId: string | undefined;
    dateOfFoundation: string | undefined;
    createdById: string | undefined;
    createdOn: string | undefined;
    modifiedById: string | undefined;
    modifiedOn: string | undefined;
    clusterStatus: ClusterStatusEnum;
    memberCount: number;
    clusterAdvisorId: string | undefined;
}

export interface AddressDto {
    country: string | undefined;
    street: string | undefined;
    city: string | undefined;
    county: string | undefined;
    zipCode: string | undefined;
    municipality: string | undefined;
    municipalityNo: string | undefined;
}

export interface ClusterDto {
    id: string;
    name: string | undefined;
    emailAddress: string | undefined;
    telephone: string | undefined;
    websiteUrl: string | undefined;
    organizationNumber: string | undefined;
    street: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    county: string | undefined;
    address: AddressDto | undefined;
    industryCode: string | undefined;
    clusterPurpose: string | undefined;
    clusterVision: string | undefined;
    inCrmAccountId: string | undefined;
    dateOfFoundation: string | undefined;
    createdById: string | undefined;
    createdOn: string | undefined;
    modifiedById: string | undefined;
    modifiedOn: string | undefined;
    clusterStatus: ClusterStatusDto | undefined;
    clusterStatusId: string | undefined;
    mainContact: ClusterUserDto | undefined;
    owner: ClusterOwnerDto | undefined;
    portfolioIndustries: PortfolioIndustryDto[];
    oneWayInCounties: string[];
    oneWayInMunicipalities: string[];
    oneWayInVmaNames: string[];
    isMunicipalityFirstLineService: boolean | undefined;
    administersProgramId: string | undefined;
    bsoContactEmail: string | undefined;
}

export interface ClusterStatusDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    operationsApplicationFrame: number | undefined;
    developmentApplicationFrame: number | undefined;
    totalApplicationFrame: number | undefined;
    modules: ModuleDto[];
    statusProgramIds: string[];
}

export interface ModuleDto {
    id: string;
    code: string | undefined;
    description: string | undefined;
}

export interface ClusterUserDto {
    id: string;
    clusterId: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    phone: string | undefined;
    responsibilities: string | undefined;
    organization: string | undefined;
    userId: string | undefined;
    role: RoleDto | undefined;
    b2CId: string | undefined;
    invitationStatus: InvitationStatus | undefined;
    invitationCode: string | undefined;
    opportunityEmailInterval: EmailInterval;
}

export interface RoleDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    roleCategory: RoleCategory;
    moduleAccesses: RoleModuleAccessDto[] | undefined;
}

export enum RoleCategory {
    Regular = "Regular",
    Board = "Board",
    Management = "Management",
    External = "External",
}

export interface RoleModuleAccessDto {
    moduleId: string;
    operation: Operation;
}

export enum Operation {
    None = "None",
    Read = "Read",
    Write = "Write",
}

export enum InvitationStatus {
    Created = "Created",
    Sent = "Sent",
    Accepted = "Accepted",
}

export enum EmailInterval {
    Monthly = "Monthly",
    Weekly = "Weekly",
    Never = "Never",
}

export interface ClusterOwnerDto {
    name: string;
    organizationNumber: string;
    crmId: string;
    ownerFrom: string;
    ownerTo: string | undefined;
}

export interface PortfolioIndustryDto {
    id: string;
    name: string;
    description: string;
}

export interface ApplicationFinancialFrameDto {
    clusterStatus: ClusterStatusEnum;
    operationsFrame: number | undefined;
    developmentFrame: number | undefined;
    totalFrame: number | undefined;
}

export interface EnvironmentInformation {
    /** Name of the environment (dev, test, prod) */
    name: string | undefined;
    /** URL to cluster portal */
    clusterPortalUrl: string | undefined;
    /** Instrumentation key for Application Insights. Will be set to null or empty when Name == "local". 
Otherwise it will be environment-specific */
    appInsightsInstrumentationKey: string | undefined;
}

export interface UserDto {
    displayName: string | undefined;
    chosenClusterId: string | undefined;
}

export interface UserDto2 {
    id: string;
    hashedB2CId: string;
    isGlobalAdmin: boolean;
    portalTermsConsentDate: string;
    clusterContacts: ClusterContactDto[];
    clusterUsers: ClusterUserDto[];
    role: RoleDto | undefined;
}

export interface ClusterContactDto {
    id: string;
    clusterId: string;
    clusterMemberId: string | undefined;
    clusterMember: ClusterMemberDto | undefined;
    status: ClusterContactStatus;
    deactivatedDate: string | undefined;
    isClusterMemberMainContact: boolean;
    firstName: string | undefined;
    lastName: string | undefined;
    mobilePhone: string | undefined;
    gender: Gender;
    description: string | undefined;
    emailAddress: string;
    timeRate: TimeRateDto;
    timeRateId: string;
    jobTitle: JobTitle | undefined;
    interestAreas: InterestAreaDto[];
}

export interface ClusterMemberDto {
    id: string;
    memberSince: string | undefined;
    name: string | undefined;
    mailingAddress: AddressDto | undefined;
    billingAddress: AddressDto | undefined;
    description: string | undefined;
    establishedDate: string | undefined;
    international: boolean | undefined;
    isActive: boolean;
    deactivatedDate: string | undefined;
    organizationNumber: string | undefined;
    orderNumber: string | undefined;
    clusterId: string;
    mainContactId: string | undefined;
    clusterMemberTypeId: string | undefined;
    clusterMemberType: ClusterMemberTypeDto | undefined;
    clusterMemberCategoryId: string | undefined;
    clusterMemberCategory: ClusterMemberCategoryDto | undefined;
    clusterMemberFee: ClusterMemberFeeDto | undefined;
    interestAreas: InterestAreaDto[];
    details: ClusterMemberDetailsDto | undefined;
}

export interface ClusterMemberTypeDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
}

export interface ClusterMemberCategoryDto {
    id: string;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
}

export interface ClusterMemberFeeDto {
    id: string;
    name: string | undefined;
    amount: number | undefined;
    clusterId: string;
}

export interface InterestAreaDto {
    id: string;
    name: string;
    description: string | undefined;
    clusterId: string;
    createdOn: string;
    createdBy: string;
}

export interface ClusterMemberDetailsDto {
    numberOfEmployees: number | undefined;
    numberOfEmployeesLastYear: number | undefined;
    isFetchedFromBrReg: boolean | undefined;
    nace: string | undefined;
    companyTypeCode: string | undefined;
    companyTypeDescription: string | undefined;
    industry: string | undefined;
    bankrupt: boolean | undefined;
    liquidation: boolean | undefined;
    forcedLiquidation: boolean | undefined;
    registryEnhetsRegisteretDate: string | undefined;
    registryMvaRegisteret: boolean | undefined;
    registryForetaksRegisteret: boolean | undefined;
    registryStiftelsesRegisteret: boolean | undefined;
    registryFrivillighetsRegisteret: boolean | undefined;
    femaleFounder: IsFemale | undefined;
    femaleCEO: IsFemale | undefined;
    femaleChairman: IsFemale | undefined;
    grossTurnover: number | undefined;
    staffCosts: number | undefined;
    resultBeforeAllocations: number | undefined;
    assetsTotal: number | undefined;
}

export enum IsFemale {
    Yes = "Yes",
    No = "No",
    Other = "Other",
}

export enum ClusterContactStatus {
    Active = "Active",
    InActive = "InActive",
    PendingApproval = "PendingApproval",
}

export enum Gender {
    Unspecified = "Unspecified",
    Male = "Male",
    Female = "Female",
    Other = "Other",
}

export interface TimeRateDto {
    name: string | undefined;
    id: string;
    hourRate: number;
    clusterId: string;
    isClusterDefault: boolean;
}

export enum JobTitle {
    ClusterManager = "ClusterManager",
    BoardChairman = "BoardChairman",
    BoardMember = "BoardMember",
    BoardVaraMember = "BoardVaraMember",
    ProjectManager = "ProjectManager",
}

export interface PermissionDtoV2 {
    permissions: { [key: string]: Operation; };
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}